@if (!ppAccount) {
  <pp-account-options-placeholder></pp-account-options-placeholder>
}

@if (ppAccount) {
  <pp-grid [ppOptions]="{ skipHeader: true }">
    <ng-container body>
      @if (ppAccount) {
        <div class="accountOptions">
          @if (ppShowHiddenOptions) {
            <pp-account-options-toggles
              [(ppAccount)]="ppAccount"
            ></pp-account-options-toggles>
          }
          @if (ppShowHiddenOptions) {
            <pp-account-options-features
              [ppAccount]="ppAccount"
              (ppUpdateFeatures)="updateAccountFeatures($event)"
            ></pp-account-options-features>
          }
          <div class="accountOptions__confirm">
            <pp-button
              ppStyle="primary"
              ppId="saveAccTypeBtn"
              [ppProcess]="updatingAccount"
              (ppAction)="updateAccount()"
              >
              {{ 'save_changes' | ppTranslate }}
            </pp-button>
          </div>
        </div>
      }
    </ng-container>
  </pp-grid>
}
